import React from 'react';

import { useMediaQuery } from 'ha/helpers/MediaQuery';
import { MapProps, RoomMarker as RoomMarkerType } from './Types';

import RoomMarkerDesktop from './RoomMarkerDesktop';
import RoomMarkerMobile from './RoomMarkerMobile';

interface Props {
  marker: RoomMarkerType;
  highlightedRoomId: number;
  lat: number;
  lng: number;
  boundariesElement?: HTMLDivElement | null;
}

const RoomMarker: React.FC<Props & Partial<MapProps>> = props => {
  const { md } = useMediaQuery();

  const highlightedInList = props.marker.rooms.some(
    room => room.id === props.highlightedRoomId,
  );

  const Marker = md ? RoomMarkerDesktop : RoomMarkerMobile;

  return <Marker {...props} highlightedInList={highlightedInList} />;
};

export default RoomMarker;
